'use client'

import { memo } from 'react'

import { ErrorDataUnavailable } from '@/components/common/Error'

const VaultV2ChartTotalDepositError = () => {
  return <ErrorDataUnavailable minHeight="395px" />
}

export default memo(VaultV2ChartTotalDepositError)
